import {
  NgModule
} from '@angular/core';
import {
  CommonModule
} from '@angular/common';


/* Do put a singleton service whose instance will be shared throughout the application */
/* Things like Logger services, exception services, a loading-spinner component etc. */

/* Reference: https://angular.io/guide/styleguide#core-feature-module */

@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class CoreModule { }
